module.exports = __webpack_public_path__ + "img/a.6ab1144a.jpg";